// extracted by mini-css-extract-plugin
export default {"markdown":"markdown__markdown___3PVSv"};